// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3zIA7","label":"Radio_label__2XrVC","checkMark":"Radio_checkMark__1t20W","disabled":"Radio_disabled__3v-qz"};